import requestWithAuth from "./httpClient";
import { rootURL } from "./rootURL";

/**
 * One month of the charts endpoint: a value for every day of that month, with
 * the days nobody worked left null. Was declared as `{ month, year, statistics
 * }`, which is the shape of a balance day rather than of this answer.
 */
export type ChartData = {
	year: string;
	month: number;
	days: number[];
	values: Array<number | null>;
};

const chartsURL = `${rootURL}charts`;

type Params = {
	yearFilter: string;
	monthFilter?: string;
	category?: string;
	translatorId?: string;
	clientId?: string;
};

export function getChartsRequest({
	yearFilter = "",
	monthFilter = "",
	category = "",
	translatorId = "",
	clientId = "",
}: Params) {
	const params = new URLSearchParams();
	if (yearFilter) params.append("yearFilter", yearFilter);
	if (monthFilter) params.append("monthFilter", monthFilter);
	if (category) params.append("category", category);
	if (translatorId) params.append("translatorId", translatorId);
	if (clientId) params.append("clientId", clientId);

	return requestWithAuth<ChartData[]>(
		"get",
		`${chartsURL}?${params.toString()}`,
	);
}
